import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { ErrorPage } from 'cpfr-common';
import { fetchForbiddenErrorPage } from './ForbiddenErrorPageSlice';
import { ForbiddenErrorPageContentSelector } from './ForbiddenErrorPageContentSelector';

export function useForbiddenErrorPage(): AbstractContentState<ErrorPage> {
    return useCmsContent(fetchForbiddenErrorPage, ForbiddenErrorPageContentSelector);
}
